
define('modules/application/wizard/classes/genericCollectionSection',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./genericElement"

  ],

  function(app, Backbone, genericElement) {

    var genericCollectionItem = _.extend({}, genericElement, {
      View: Backbone.View.extend({
        events: {
          "click button.delete": "deleteButtonClickedEventHandler",
          "click button.duplicate": "duplicateButtonClickedEventHandler",
          "click .toggleInfoButton": "toggleInfos"
        },
        serialize: function() {
          return {
            view: this,
            model: this.model,
            app: app
          };
        },
        initialize: function() {},
        setAsSelected: function() {
          this.model.set("selected", true);
        },

        toggleInfos: function(e) {
          return genericElement.Views.content.prototype.toggleInfos(e, this);
        },

        deleteButtonClickedEventHandler: function() {
          this.model.get('collectionEventAggregator').trigger('delete:requested', this.model);
        },

        duplicateButtonClickedEventHandler: function() {
          this.model.get('collectionEventAggregator').trigger('duplication:requested', this.model);
        },

        beforeRender: function() {
          var isSelected = this.model.get("selected");
          if (isSelected)
            this.$el.addClass("selected");
          else
            this.$el.removeClass("selected");
        },
        afterRender: function() {
          window.customizeFormElements.call();
        }
      }),
      Model: Backbone.Model.extend({
        initialize: function() {
          this.bind("change:selected", this.selectedStatusChangedEventHandler, this);
        },
        selectedStatusChangedEventHandler: function() {
          if (this.get("selected"))
            this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
          this.trigger("render:requested");
        }
      })
    });

    var genericCollectionSection = _.extend({}, genericElement, {

      Views: {

        titleBar: genericElement.Views.titleBar.extend({
          template: "application/wizard/sections/genericCollectionSection/titleBar",
          tagName: "h3",
          initialize: function() {
            var that = this;

            this.model.unbind("updateViews", this.setLabel);
            this.model.bind("updateViews", this.setLabel, this);

            this.model.unbind("item:added", this.growlItemAdded);
            this.model.bind("item:added", this.growlItemAdded, this);

            this.model.unbind("item:removed", this.growlItemRemoved);
            this.model.bind("item:removed", this.growlItemRemoved, this);

            this.model.bind('packages:fetching', this.setLoadingLabel, this);
            this.model.bind('packages:fetched', this.setLabel, this);
          },


          setLabel: function(labelContent) {
            var caption = this.$el.find(".caption");
            if ((labelContent) && (labelContent !== "")) {
              if (caption.is(".hidden"))
                caption.hide(0, function() {
                  $(this).removeClass("hidden");
                  caption.html(labelContent);
                  caption.fadeIn(200);
                });
              else
                caption.html(labelContent);
            } else {
              if (!caption.is(".hidden")) {
                caption.fadeOut(200, function() {
                  $(this).addClass("hidden");
                });
              }
            }
          },
          setLoadingLabel: function() {
            var caption = this.$el.find(".caption"),
              labelContent = $.i18n._("IDS_W4_9010");

            if (caption.is(".hidden"))
              caption.hide(0, function() {
                $(this).removeClass("hidden");
                caption.html(labelContent);
                caption.fadeIn(200);
              });
            else
              caption.html(labelContent);
          },
          growlItemAdded: function() {
            var growl = $("<span class=\"growl\"></span>");

            if (this.$el.find(".growl").length > 0)
              growl = this.$el.find(".growl");

            growl.text("Item added");
            growl.hide();
            this.$el.find(".caption").after(growl);

            growl.fadeIn(50, function() {
              setTimeout(function() {
                growl.fadeOut(400, function() {
                  growl.remove();
                });
              }, 1000);
            });
          },

          growlItemRemoved: function() {
            var growl = $("<span class=\"growl\"></span>");

            if (this.$el.find(".growl").length > 0)
              growl = this.$el.find(".growl");

            growl.text("Item removed");
            growl.hide();
            this.$el.find(".caption").after(growl);

            growl.fadeIn(50, function() {
              setTimeout(function() {
                growl.fadeOut(400, function() {
                  growl.remove();
                });
              }, 1000);
            });
          },

          removeLabel: function() {
            this.$el.find(".titleBarcontent span").fadeOut(200, function() {
              $(this).hide();
            });
          },
          afterRender: function() {
            var captionTag = this.$el.find(".caption");
            if (captionTag.html() === "")
              captionTag.hide();
            else
              captionTag.show();
          },

          onClose: function() {
            this.model.unbind("updateViews", this.setLabel);
            this.model.unbind("item:added", this.growlItemAdded);
            this.model.unbind("item:removed", this.growlItemRemoved);
          }
        }),

        content: genericElement.Views.content.extend({
          template: "application/wizard/sections/genericCollectionSection/content",
          className: "genericCollectionSection",
          events: {
            "click .addItem": "addItemButtonClickedEventHandler"
          },

          initialize: function() {
            this.model.bind("render:requested", this.render, this);
            this.model.bind("item:removed", this.itemRemovedEventHandler, this);
          },
          serialize: function() {
            return genericElement.Views.content.prototype.serialize.apply(this);
          },
          toggleInfos: function(e, currentScope) {
            return genericElement.Views.content.prototype.toggleInfos(e, currentScope);
          },
          itemRemovedEventHandler: function(itemRemovedModel) {
            var viewToRemove = this.getView(function(iterableView) {
              return iterableView.model === itemRemovedModel;
            });

            if (viewToRemove) {
              viewToRemove.remove();
            }
          },

        })
      },

      Model: genericElement.Model.extend({
        defaults: {
          startNumber: 1,
          minItem: 0,
          maxItem: 9
        },
        initialize: function() {
          var collectionModel = Backbone.Collection.extend({
            model: genericCollectionItem.Model
          });
          if (!this.get("collection") || this.get("collection").length===0)
            this.set("collection", new collectionModel());

          this.get("collectionEventAggregator").unbind("duplication:requested", this.duplicationRequestedEventHandler);
          this.get("collectionEventAggregator").bind("duplication:requested", this.duplicationRequestedEventHandler, this);
          this.get("collectionEventAggregator").unbind("delete:requested", this.deleteRequestedEventHandler);
          this.get("collectionEventAggregator").bind("delete:requested", this.deleteRequestedEventHandler, this);
        },

        deleteRequestedEventHandler: function(modelToDelete) {
          this.removeItem(modelToDelete);
        },

        duplicationRequestedEventHandler: function(modelToDuplicate) {
          this.duplicateItem(modelToDuplicate);
        },

        addItem: function(modelToAdd) {
          var toAdd = modelToAdd,
            collection = this.get("collection"),
            collectionLength = collection.length;
          if (!toAdd) {
            toAdd = new genericCollectionItem.Model({
              number: this.getNewNumber(),
              collectionEventAggregator: this.get("collectionEventAggregator")
            });
          }

          if ((!this.get("maxItem")) || ((collectionLength + 1) <= this.get("maxItem"))) {
            collection.add(toAdd);
            this.set("collection",collection);
            this.trigger("item:added", toAdd);
            return true;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        duplicateItem: function(modelToDuplicate) {
          var itemNumber = this.getNewNumber(),
            newModel;

          if (modelToDuplicate) {
            newModel = new genericCollectionItem.Model(modelToDuplicate.attributes);
            if (newModel) {
              newModel.set("number", itemNumber);
              return this.addItem(newModel);
            } else
              return false;
          } else
            return false;
        },

        deleteItem: function(modelToDelete, force) {
          var dontRequestConfirm = force,
            i = 0;
          if (!dontRequestConfirm)
            dontRequestConfirm = false;

          var collection = this.get("collection"),
            collectionLength = collection.length;
          if ((dontRequestConfirm) || (confirm($.i18n._("IDS_W1_9088")))) {
            if ((collectionLength - 1) >= this.get("minItem")) {
              collection.remove(modelToDelete);
              this.set("collection",collection);

              for (i = modelToDelete.length - 1; i > 0; i--)
                modelToDelete[i].destroy();

              this.trigger("item:removed", modelToDelete[i]);
              return true;
            } else {
              alert("You have reached the minimum number of items");
              return false;
            }
          }
        },

        getNewNumber: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          if (collectionLength > 0)
            return (collection.models[collectionLength - 1].get("number") + 1);
          else
            return this.get("startNumber");
        }
      }),

      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return genericCollectionSection;

  });